import React from 'react';
import { Row, Col } from 'rsuite';
import { Link } from 'react-router-dom'


export class PrivacyLink extends React.Component {
    render() {
        return (
            <Row style={{ marginTop: 30}}>
                <Col>
                    <Link style={{color: '#a4a9b3'}} to="/privacy">Privacy Policy</Link>                
                    </Col>
            </Row>
        )
    }
}